import { useTranslation } from 'react-i18next';
import { Navigate } from 'react-router-dom';

import { useDetailsNext } from '@/features/institution/hooks/useDetailsNext';
import { INSTITUTION_DETAILS_TYPE } from '@/features/institution/utils';
import { useProfileVerificationInformation } from '@/hooks/queries/use-profile-verification-information';
import LoadingPage from '@/pages/loading';

const InstitutionOnboardingInitialRedirectPage = () => {
  const { isLoading: isLoadingInstitutionDetailsNext, data: institutionDetailsNext } = useDetailsNext(INSTITUTION_DETAILS_TYPE.ONBOARDING);
  const { isLoading: isLoadingVerificationInformation, data: verificationInformation } = useProfileVerificationInformation();
  const { t } = useTranslation();
  const isLoading = isLoadingInstitutionDetailsNext || isLoadingVerificationInformation;
  const { status: verificationStatus } = verificationInformation?.verification ?? {};

  if (isLoading)
    return (
      <LoadingPage>
        <p>{t('redirectingToNextStep')}</p>
      </LoadingPage>
    );

  if (institutionDetailsNext?.route) return <Navigate to={institutionDetailsNext.route} replace />;

  if (!verificationStatus || verificationStatus === 'NOT_VERIFIED') return <Navigate to="/institution/onboarding/verification" replace />;

  return <Navigate to="/institution/onboarding/complete" replace />;
};
InstitutionOnboardingInitialRedirectPage.displayName = 'InstitutionOnboardingInitialRedirectPage';

export default InstitutionOnboardingInitialRedirectPage;
